import { type ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";
import type { SlotId } from "@skilitics/nautilus-core-designer-data";

import type { NodeSelectionCriteria } from "../../../library";
import { useManagedSlotPasteClipboard } from "../../../slots";

interface Props {
  slotId: SlotId;
  criteria: NodeSelectionCriteria;
  children: ReactNode;
}

export const PasteToSlotMenuItem = ({ slotId, criteria, children }: Props) => {
  const { paste, canPasteHere } = useManagedSlotPasteClipboard({
    target: { slotId },
    criteria,
  });
  return (
    <MenuItem onClick={() => paste()} disabled={!canPasteHere.value}>
      {children}
    </MenuItem>
  );
};
